/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedVentureFundVariantRequestDto } from '../../models/backend-patched-venture-fund-variant-request-dto';
import { BackendVentureFundVariantDto } from '../../models/backend-venture-fund-variant-dto';

export interface VentureFundsVentureFundVariantsPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedVentureFundVariantRequestDto;
}

export function ventureFundsVentureFundVariantsPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsVentureFundVariantsPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendVentureFundVariantDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsVentureFundVariantsPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendVentureFundVariantDto>;
    }),
  );
}

ventureFundsVentureFundVariantsPartialUpdate$FormData.PATH = '/api/venture_funds/venture-fund-variants/{id}/';
